import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core";
import { Warning } from "@material-ui/icons";

interface PbhServiceableRequiredDialogProps {
  open: boolean;
  onClose: () => void;
  onNavigateToServiceable: () => void;
}

const PbhServiceableRequiredDialog: React.FC<PbhServiceableRequiredDialogProps> = ({
  open,
  onClose,
  onNavigateToServiceable,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="serviceable-required-dialog-title"
      aria-describedby="serviceable-required-dialog-description"
    >
      <DialogTitle id="serviceable-required-dialog-title">
        <Warning style={{ verticalAlign: "middle", marginRight: 8 }} />
        Serviceable Accept/Reject Required
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="serviceable-required-dialog-description">
          For this part, you must first make a Rejected/Accepted selection on the Serviceable screen.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">
          Cancel
        </Button>
        <Button onClick={onNavigateToServiceable} color="primary" variant="contained" autoFocus>
          Go to Serviceable Tab
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PbhServiceableRequiredDialog;
